import React from "react";
import { Dropdown } from "semantic-ui-react";
import { downloadFile } from "utils/utility";
import * as YAML from "yaml";

const apiTypes = [
  { name: "JSON", mediaType: "application/json", extension: "json" },
  { name: "YAML", mediaType: "application/yaml", extension: "yaml" },
];

export default class DownloadApi extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  executeDownload = (type) => {
    const stringifiedContent =
      "JSON" === type.name
        ? JSON.stringify(this.props.api.content, null, 2)
        : YAML.stringify(this.props.api.content, null, 2);
    downloadFile(
      new Blob([stringifiedContent], { type: type.mediaType }),
      this.props.api.name + "." + type.extension
    );
  };

  render() {
    return (
      <Dropdown simple button text="Download API">
        <Dropdown.Menu>
          {apiTypes.map((apiType) => (
            <Dropdown.Item
              key={apiType.name}
              onClick={() => this.executeDownload(apiType)}
            >
              {apiType.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
